import React from 'react'

import { StrategyMemoArchiveList } from './components/StrategyMemoArchiveList'

export const StrategyMemoArchiveListPage = () => <StrategyMemoArchiveList />
